// Used to store the state of the new single player expand node
export var expandedState = new WeakMap();

// used to determine if the expand is expanded or collapsed
export var isExpandCollapsed = function isExpandCollapsed(node) {
  var _expandedState$get;
  return (_expandedState$get = !expandedState.get(node)) !== null && _expandedState$get !== void 0 ? _expandedState$get : false;
};